/* eslint-disable import/prefer-default-export */
import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { OnboardingContext } from '../../../../contexts/onboarding/context';
import { SIGNUP_STEPS_COUNT } from '../constants';

export const OnboardingBodyLayout = ({
  children,
  withBack,
  onPrevClick,
  title,
  className,
  renderButtons,
}) => {
  const { t: translate } = useTranslation();

  const { state, openRegistrationStepsPopup } = useContext(OnboardingContext);

  const currentScreen = state?.currentScreen;
  const signupSteps = state?.signupSteps;

  const showStepsLabel = useMemo(() => {
    if (currentScreen && signupSteps) {
      const signupStepskeys = Object.keys(signupSteps);
      return signupStepskeys.includes(currentScreen);
    }
    return false;
  }, [currentScreen, signupSteps]);

  return (
    <div
      className={`d-flex flex-column main-layout-body-container letter-spacing-sm ${className} onboarding-body-outer-container main-body-layout`}>
      {(withBack || showStepsLabel) && (
        <div className="d-flex flex-row justify-content-between align-items-center">
          {withBack && (
            <div
              className="cursor-pointer text-hover"
              onClick={onPrevClick}
              onKeyDown={onPrevClick}
              role="presentation">
              <i className="icon icon-arrow_back-navigation text-f5 me-2" aria-label="Back" />
            </div>
          )}
          <div className="d-flex d-md-none flex-row text-bold align-items-center justify-content-end w-100">
            {showStepsLabel && (
              <div
                onClick={openRegistrationStepsPopup}
                onKeyDown={openRegistrationStepsPopup}
                role="button"
                tabIndex={-1}>
                <p className="text-primary text-f5">
                  {translate('signup_steps_label')
                    .replace('__CURRENTSTEP__', signupSteps[currentScreen].step)
                    .replace('__TOTAL__', SIGNUP_STEPS_COUNT)}
                </p>
              </div>
            )}
          </div>
        </div>
      )}
      <div className="d-flex flex-row justify-content-between align-items-center mt-3 mt-md-4 mb-md-3">
        <p className="text-dark d-none d-md-block text-f3 text-bold">{title}</p>
        <p className="text-dark text-bold d-block d-md-none text-f4">{title}</p>
      </div>
      <div className="onboarding-body-children-container">{children}</div>
      {renderButtons && (
        <div className="d-flex flex-row justify-content-center w-100 onboarding-body-btn-container">
          <div
            className="onboarding-body-btn-container-inner letter-spacing-sm"
            style={{
              bottom: '4%',
            }}>
            {renderButtons()}
          </div>
        </div>
      )}
    </div>
  );
};

OnboardingBodyLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  withBack: PropTypes.bool,
  title: PropTypes.string,
  className: PropTypes.string,
  onPrevClick: PropTypes.func,
  renderButtons: PropTypes.func,
};

OnboardingBodyLayout.defaultProps = {
  withBack: false,
  title: null,
  children: null,
  className: '',
  onPrevClick: null,
  renderButtons: null,
};
